<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t(pagetitle) }}</h3>
      </div>

      <form class="form-horizontal">
        <div class="box-body">
          <div class="col-md-6">
            <!-- BEGIN - 
                        _number From -->

            <div class="form-group">
              <label for="name" class="col-sm-3 control-label">{{
                $t("invoice.invoice_number")
              }}</label>

              <div class="col-sm-9">
                <input
                  style="width: 100%;"
                  v-model="invoicedata.invoice_number"
                  type="text"
                  class="form-control"
                  id="invoice_number"
                  :placeholder="$t('invoice.invoice_number')"
                  disabled
                />
              </div>
            </div>

            <!-- END - invoice_number From -->
          </div>

          <div class="col-md-6">
            <!-- BEGIN - status_name From -->

            <div class="form-group">
              <label for="name" class="col-sm-3 control-label">{{
                $t("invoice.status_name")
              }}</label>

              <div class="col-sm-9">
                <b-form-select
                  style="width: 100%;"
                  :options="statusList"
                  required
                  v-model="invoicedata.invoice_status"
                  class="form-control"
                  :disabled="disabledStatusList ? false : true"
                />
              </div>
            </div>

            <!-- END - status_name From -->
          </div>

          <div class="col-md-6">
            <!-- BEGIN - date_issued From -->

            <div class="form-group">
              <label for="date_issued" class="col-sm-3 control-label">{{
                $t("invoice.date_issued")
              }}</label>

              <div class="col-sm-9">
                <div class="input-group date">
                  <div class="input-group-addon">
                    <i class="fa fa-calendar"></i>
                  </div>

                  <date-picker
                    v-model="form.date_issued"
                    :config="options"
                    @dp-change="getDueDate"
                    disabled
                  ></date-picker>
                </div>
              </div>

              <!-- /.input group -->
            </div>

            <!-- END - date_issued From -->
          </div>

          <div class="col-md-6">
            <!-- BEGIN - Month From -->

            <div class="form-group">
              <label for="month" class="col-sm-3 control-label">{{
                $t("invoice.month")
              }}</label>

              <div class="col-sm-9">
                <input
                  style="width: 100%;"
                  v-model="invoicedata.periodSelected"
                  type="text"
                  class="form-control"
                  :placeholder="$t('invoice.month')"
                  disabled
                />

              </div>

              <!-- /.input group -->
            </div>

            <!-- END - Month From -->
          </div>

          <div class="col-md-6">
            <!-- BEGIN - due_date From -->

            <div class="form-group">
              <label for="due_date" class="col-sm-3 control-label">{{
                $t("invoice.due_date")
              }}</label>

              <div class="col-sm-9">
                <div class="input-group date">
                  <div class="input-group-addon">
                    <i class="fa fa-calendar"></i>
                  </div>

                  <date-picker
                    v-model="form.due_date"
                    :config="options"
                    disabled
                  ></date-picker>
                </div>
              </div>

              <!-- /.input group -->
            </div>

            <!-- END - due_date From -->
          </div>

          <div class="col-md-6" v-if="false">
            <!-- BEGIN - date_paid From -->

            <div class="form-group">
              <label for="date_paid" class="col-sm-3 control-label">{{
                $t("invoice.date_paid")
              }}</label>

              <div class="col-sm-9">
                <div class="input-group date">
                  <div class="input-group-addon">
                    <i class="fa fa-calendar"></i>
                  </div>

                  <date-picker
                    v-model="form.date_paid"
                    :config="options"
                  ></date-picker>
                </div>
              </div>

              <!-- /.input group -->
            </div>

            <!-- END - date_paid From -->
          </div>

          <div class="col-md-6">
            <!-- BEGIN - apartment From -->

            <div class="form-group">
              <label for="apartment_code" class="col-sm-3 control-label">{{
                $t("invoice.apartment_code")
              }}</label>

              <div class="col-sm-9">
                <b-form-select
                  v-if="this.$route.params.id == 0"
                  :options="optionApartmentList"
                  v-model="invoicedata.apartment_id"
                  required
                  class="form-control"
                  @change="onChangeApartment"
                  :disabled="apartmentDisabledList ? false : true"
                />
                <input
                  v-else
                  v-model="invoicedata.apartment_code"
                  type="text"
                  class="form-control"
                  id="apartment_code"
                  :disabled="true"
                />
              </div>
            </div>

            <!-- END - apartment From -->
          </div>

          <div class="col-md-6" v-if="false">
            <!-- BEGIN - other_details From -->

            <div class="form-group">
              <label for="other_details" class="col-sm-3 control-label">{{
                $t("invoice.other_details")
              }}</label>

              <div class="col-sm-9">
                <input
                  v-model="invoicedata.other_details"
                  type="text"
                  class="form-control"
                  id="other_details"
                  :placeholder="$t('invoice.other_details')"
                />
              </div>
            </div>

            <!-- END - other_details From -->
          </div>
        </div>

        <div style="display: none">
          <!-- BEGIN - box-primary -->

          <!-- <hr /> -->

          <div class="">
            <!-- BEGIN - box-header -->

            <div class="box-header">
              <h3 class="box-title">
                {{ $t("invoice.invoice_info_mainowner") }}
              </h3>
            </div>

            <!-- END - box-header -->

            <!-- BEGIN - box-body -->

            <div class="box-body">
              <div class="col-md-6">
                <!-- BEGIN - mainowner_fullname From -->

                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.mainowner_fullname")
                  }}</label>

                  <div class="col-sm-9">
                    <input
                      v-model="invoiceDataInfo.mainowner_fullname"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- END - mainowner_fullname From -->
              </div>

              <div class="col-md-6">
                <!-- BEGIN - mainowner_address From -->

                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.mainowner_address")
                  }}</label>

                  <div class="col-sm-9">
                    <input
                      v-model="invoiceDataInfo.mainowner_address"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- END - mainowner_address From -->
              </div>

              <div class="col-md-6">
                <!-- BEGIN - mainowner_country From -->

                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.mainowner_country")
                  }}</label>

                  <div class="col-sm-9">
                    <input
                      v-model="invoiceDataInfo.mainowner_country"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- END - mainowner_country From -->
              </div>

              <div class="col-md-6">
                <!-- BEGIN - mainowner_email From -->

                <div class="form-group">
                  <label for="mainowner_email" class="col-sm-3 control-label">{{
                    $t("invoice.mainowner_email")
                  }}</label>

                  <div class="col-sm-9">
                    <input
                      v-model="invoiceDataInfo.mainowner_email"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- END - mainowner_email From -->
              </div>

              <div class="col-md-6">
                <!-- BEGIN - mainowner_phone From -->

                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.mainowner_phone")
                  }}</label>

                  <div class="col-sm-9">
                    <input
                      v-model="invoiceDataInfo.mainowner_phone"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- END - mainowner_phone From -->
              </div>

              <div class="col-md-6">
                <!-- BEGIN - mainowner_tax From -->

                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.mainowner_tax")
                  }}</label>

                  <div class="col-sm-9">
                    <input
                      v-model="invoiceDataInfo.mainowner_tax"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- END - mainowner_tax From -->
              </div>

              <!-- [loitt] - #1171 GHI NHẬN THÔNG TIN XUẤT HOÁ ĐƠN -->
              <div class="col-md-6">
                <!-- BEGIN - profile_company_name From -->
                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.profile_company_name")
                  }}</label>
                  <div class="col-sm-9">
                    <input
                      v-model="invoiceDataInfo.profile_company_name"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>
                <!-- END - profile_company_name From -->
              </div>
              <div class="col-md-6">
                <!-- BEGIN - profile_company_address From -->
                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.profile_company_address")
                  }}</label>
                  <div class="col-sm-9">
                    <input
                      v-model="invoiceDataInfo.profile_company_address"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>
                <!-- END - profile_company_address From -->
              </div>
              <div class="col-md-6">
                <!-- BEGIN - profile_company_tax_code From -->
                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.profile_company_tax_code")
                  }}</label>
                  <div class="col-sm-9">
                    <input
                      v-model="invoiceDataInfo.profile_company_tax_code"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>
                <!-- END - profile_company_tax_code From -->
              </div>
              <div class="col-md-6">
                <!-- BEGIN - profile_company_email From -->
                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.profile_company_email")
                  }}</label>
                  <div class="col-sm-9">
                    <input
                      v-model="invoiceDataInfo.profile_company_email"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>
                <!-- END - profile_company_email From -->
              </div>
            </div>

            <!-- END - box-body -->
          </div>

          <!-- END - box-primary -->
        </div>

        <!-- <hr /> -->

        <div style="display: none">
          <div class="">
            <div class="box-header">
              <h3 class="box-title">
                {{ $t("invoice.invoice_info_resident") }}
              </h3>
            </div>

            <div class="box-body">
              <div class="col-md-6">
                <!-- BEGIN - user From -->

                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.invoice_resident_fullname")
                  }}</label>

                  <div class="col-sm-9">
                    <b-form-select
                      v-if="this.$route.params.id == 0"
                      :options="optionUserList"
                      v-model="invoicedata.invoice_user"
                      required
                      class="form-control"
                      @change="onChangeUser"
                      :disabled="userDisabledList ? false : true"
                    />
                    <input
                      v-else
                      v-model="invoiceDataInfo.resident_fullname"
                      type="text"
                      class="form-control"
                      id="resident_fullname"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- END - user From -->
              </div>

              <div class="col-md-6">
                <!-- BEGIN - resident_address From -->

                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.resident_address")
                  }}</label>

                  <div class="col-sm-9">
                    <input
                      v-model="invoiceDataInfo.resident_address"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- END - resident_address From -->
              </div>

              <div class="col-md-6">
                <!-- BEGIN - resident_country From -->

                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.resident_country")
                  }}</label>

                  <div class="col-sm-9">
                    <input
                      v-model="invoiceDataInfo.resident_country"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- END - resident_country From -->
              </div>

              <div class="col-md-6">
                <!-- BEGIN - resident_email From -->

                <div class="form-group">
                  <label for="resident_email" class="col-sm-3 control-label">{{
                    $t("invoice.resident_email")
                  }}</label>

                  <div class="col-sm-9">
                    <input
                      v-model="invoiceDataInfo.resident_email"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- END - resident_email From -->
              </div>

              <div class="col-md-6">
                <!-- BEGIN - resident_phone From -->

                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.resident_phone")
                  }}</label>

                  <div class="col-sm-9">
                    <input
                      v-model="invoiceDataInfo.resident_phone"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- END - resident_phone From -->
              </div>

              <div class="col-md-6">
                <!-- BEGIN - resident_tax From -->

                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.resident_tax")
                  }}</label>

                  <div class="col-sm-9">
                    <input
                      v-model="invoiceDataInfo.resident_tax"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- END - resident_tax From -->
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="" style="display: none">
            <div class="box-body">
              <div class="col-md-12">
                <!-- BEGIN - service From -->

                <div class="form-group">
                  <label for="name" class="col-sm-2 control-label">{{
                    $t("invoice.invoice_usage")
                  }}</label>

                  <div class="col-sm-10">
                    <multiselect
                      :options="optionService"
                      v-model="optionServiceSelected"
                      tag-placeholder="Add this as new tag"
                      placeholder="Search or Add a Services Available"
                      label="name"
                      track-by="id"
                      :multiple="true"
                      @input="onChangeService"
                      :taggable="true"
                      @tag="addService"
                      :disabled="disabledOptionService ? false : true"
                    ></multiselect>
                  </div>
                </div>

                <!-- END - service From -->
              </div>
            </div>
          </div>

          <!-- <hr /> -->

          <div class="" style="display: none">
            <!-- BEGIN - box-header [Bank Transfer] -->

            <div class="box-header">
              <h3 class="box-title">{{ $t("invoice.bank_transfer") }}</h3>
            </div>

            <!-- END - box-header -->

            <!-- BEGIN - box-body -->

            <div class="box-body">
              <div class="col-md-6">
                <!-- BEGIN - account_no From -->

                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.bank_transfer_account_no")
                  }}</label>

                  <div class="col-sm-9">
                    <input
                      v-model="invoicedata.banktransfer.account_no"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- END - account_no From -->
              </div>

              <div class="col-md-6">
                <!-- BEGIN - account_name From -->

                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.bank_transfer_account_name")
                  }}</label>

                  <div class="col-sm-9">
                    <input
                      v-model="invoicedata.banktransfer.account_name"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- END - account_name From -->
              </div>

              <div class="col-md-6">
                <!-- BEGIN - transferring_content From -->

                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.bank_transfer_transferring_content")
                  }}</label>

                  <div class="col-sm-9">
                    <input
                      v-model="invoicedata.banktransfer.transferring_content"
                      type="text"
                      class="form-control"
                      :disabled="false"
                    />
                  </div>
                </div>

                <!-- END - transferring_content From -->
              </div>

              <div class="col-md-6">
                <!-- BEGIN - contact_us From -->

                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">{{
                    $t("invoice.bank_transfer_contact_us")
                  }}</label>

                  <div class="col-sm-9">
                    <input
                      v-model="invoicedata.banktransfer.contact_us"
                      type="text"
                      class="form-control"
                      :disabled="true"
                    />
                  </div>
                </div>

                <!-- END - contact_us From -->
              </div>
            </div>

            <!-- END - box-body -->
          </div>

          <!-- END - box-primary -->

          <hr />

          <!-- BEGIN - Show list Service Usage From -->

          <div>
            <div class="">
              <div class="box-header">
                <h3 class="box-title">{{ $t("invoice.invoice_usage") }}</h3>
              </div>

              <div class="box-body">
                <div>
                  <b-table
                    :items="items"
                    :fields="fields"
                    class="mt-3"
                    outlined
                  >
                    <template #head()="scope">
                      <div>{{ $t(scope.label) }}</div>
                    </template>
                    <template #cell(status)="row">
                      <b-form-select
                        v-if="
                          row.item.isReadOnly == false &&
                            row.item.status != null
                        "
                        v-model="row.item.status.id"
                        :options="itemStatusList"
                        class="mb-3"
                        :disabled="false"
                        @change="onSelected(row)"
                      >
                      </b-form-select>
                      <span
                        v-else-if="
                          row.item.isReadOnly == true && row.item.status != null
                        "
                      >
                        <span
                          class="label label-success"
                          v-if="row.item.status.status_code === 'P'"
                          >{{ $t("apartment.paid") }}</span
                        >
                        <span
                          class="label label-warning"
                          v-else-if="row.item.status.status_code === 'L'"
                          >{{ $t("invoice.invoice_status.L") }}</span
                        >
                        <span
                          class="label label-warning"
                          v-else-if="row.item.status.status_code === 'O'"
                          >{{ $t("apartment.open") }}</span
                        >
                        <span
                          class="label label-primary"
                          v-else-if="row.item.status.status_code === 'I'"
                          >{{ $t("apartment.issue") }}</span
                        >
                      </span>
                    </template>

                    <template #cell(amount)="row">
                      <span class="label label-success">{{
                        formatTotalFee(row.item.amount)
                      }}</span>
                    </template>
                    <template #cell(last_value)="row">
                      <div style="text-align: right;">
                        <span>{{ row.item.last_value }}</span>
                      </div>
                    </template>

                    <template #cell(current_value)="row">
                      <div style="text-align: right;">
                        <span>{{ row.item.current_value }}</span>
                      </div>
                    </template>

                    <template #cell(price_unit)="row">
                      <div style="text-align: right;">
                        <span class="label label-info">{{
                          formatTotalFee(row.item.price_unit)
                        }}</span>
                      </div>
                    </template>

                    <template #cell(vatAmount)="row">
                      <span class="label label-info">{{
                        formatTotalFee(row.item.vatAmount)
                      }}</span>
                    </template>

                    <template #cell(total_all)="row">
                      <div style="text-align: right;">
                        <span class="label label-success">{{
                          formatTotalFee(row.item.total_all)
                        }}</span>
                      </div>
                    </template>

                    <!-- Date From Date To -->
                    <template #cell(date_from)="row">
                      <span v-if="row.item.is_current_month == true">
                        <span class="label label-darkcyan">{{
                          row.value
                        }}</span>
                      </span>
                      <span v-else>
                        <span class="label label-crimson">{{ row.value }}</span>
                      </span>
                    </template>
                    <template #cell(date_to)="row">
                      <span v-if="row.item.is_current_month == true">
                        <span class="label label-darkcyan">{{
                          row.value
                        }}</span>
                      </span>
                      <span v-else>
                        <span class="label label-crimson">{{ row.value }}</span>
                      </span>
                    </template>
                    <template #cell(vat_currency)="row">
                      <span class="label label-info">{{
                        formatTotalFee(row.item.vat_currency)
                      }}</span>
                    </template>
                    <template #cell(in_debt_value)="row">
                      <span class="label label-warning">{{
                        formatTotalFee(row.item.in_debt_value)
                      }}</span>
                    </template>
                    <!-- Date From Date To -->
                    <!--info(row.item, row.index, $event.target)-->
                    <template
                      #cell(actions)="row"
                    >
                      <button
                        type="button"
                        class="btn btn-labeled btn-warning pull-right"
                        @click="openModalEinvoice('modal-einvoice', row.item)"
                        style="margin-right: 5px;height:31px;"
                      >
                        <span class="btn-label">
                          <i class="fa fa-envelope-o"></i>
                        </span>
                        {{ $t("invoice.einvoice.button.einvoice") }}
                      </button>
                    </template>
                    <template
                      slot="actions1"
                      slot-scope="row"
                      v-if="row.item.show_action"
                    >
                      <div class="btn-group dropup">
                        <button
                          type="button"
                          class="btn btn-danger dropdown-toggle"
                          data-toggle="dropdown"
                        >
                          Actions

                          <span class="caret"></span>

                          <span class="sr-only">{{
                            $t("common.dropdown")
                          }}</span>
                        </button>

                        <ul class="dropdown-menu" role="menu">
                          <li>
                            <a
                              @click="info(row.item, row.index, $event.target)"
                              >{{ $t("common.edit") }}</a
                            >
                          </li>

                          <li>
                            <a>{{ $t("common.delete") }}</a>
                          </li>
                        </ul>
                      </div>
                    </template>
                  </b-table>
                  <hr />
                </div>
              </div>
            </div>
          </div>
          <!-- END - Show list Service Usage From -->
        </div>

        <div
          v-show="is_show_reset_liability"
          style="border:orange solid; padding:2rem"
        >
          {{ $t("invoice.reset_liability") }}
          <button
            class="btn btn-primary"
            @click.stop.prevent="show_hide_liability"
          >
            Ẩn
          </button>
        </div>

        <div class="box-footer">
          <button
            type="button"
            class="btn btn-labeled btn-danger"
            @click="cancelInvoiceList"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i></span> {{ $t("common.back") }}
          </button>
          <button
            type="button"
            class="btn btn-labeled btn-warning pull-right"
            @click="showPrintPdf"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-print"></i></span> {{ $t("common.printPdf") }}
          </button>
          <!-- <button
                    type="button"
                    class="btn btn-labeled btn-success pull-right"
                    @click="saveInvoiceList"
                    style="margin-right: 5px;"
                ><span class="btn-label">
                    <i class="glyphicon glyphicon-ok"></i>
                </span>{{$t('common.save')}}
            </button> -->

          <!-- <button
                    v-show="isShowOnCreateReceipt"
                    type="button"
                    class="btn btn-labeled btn-success pull-right"
                    @click="onCreateReceipt"
                    style="margin-right: 5px;"
                >
                <span class="btn-label">
                    <i class="glyphicon glyphicon-registration-mark"></i>
                </span>{{$t('invoice.invoice_receipt.button_receipt')}}
            </button> -->

          <!-- <button
            v-if="invoicedata.exported_to_liability === false"
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="onCreateLiabilit"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-registration-mark"></i> </span
            >{{ $t("invoice.invoice_receipt.button_liability") }}
          </button> -->
        </div>
      </form>
    </div>

    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>

    <!-- BEGIN - Modalmodal confirm hide liability -->
    <div class="modal fade" id="modal-confirm-hide-liability">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">
              {{ $t("invoice.confirm_hide_modal_title") }}
            </h3>
          </div>
          <div class="modal-body">
            {{ $t("invoice.confirm_hide_modal_body") }}
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="confirmHideLiability"
              class="btn btn-primary btn-sm pull-right"
            >
              Xác Nhận
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <!-- end modal confirm hide liability -->

    <!-- BEGIN - Modal modal-main-liability -->
    <div class="modal fade" :ref="`modal-main-liability`">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("invoice.liability.title") }}</h4>
          </div>
          <div class="modal-body">
            <p>
              {{
                $t("invoice.liability.confirm", { "0": this.$route.params.id })
              }}
            </p>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onSaveLiability"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- END - /.Modal modal-main-liability -->
    <!--modal-einvoice-->
    <lte-modal-einvoice
      ref="LTEModalEInvoiceBkav"
      :item="einvoice_bkav"
      @closeModal="closeModalApartment('modal-einvoice')"
    ></lte-modal-einvoice>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <router-view></router-view>
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
// https://vue-multiselect.js.org/
import "vue-multiselect/dist/vue-multiselect.min.css";
import Multiselect from "vue-multiselect";
import moment from "moment";
import LTEModal from "@/components/LTEModal.vue";
import utils from '@/lib/utils';
import InvoiceTemplateEnum from "@/enum/invoiceTemplateEnum"
import Loading from "vue-loading-overlay";
import i18n from "../../lang";
import LTEModalEInvoiceBkav from "@/components/LTEModalEInvoiceBkav";

export default {
  name: "InvoiceAdd",
  data() {
    return {
      // fields for show list service Usage
      fields: [
        {
          key: "service_usage_id",
          label: "common.nonumber",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "service_name",
          label: "service.servicename",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "service_code",
          label: "service.servicecode",
          sortable: true,
          class: "text-center"
        },
        // {
        //   key: "date_from",
        //   label: "common.datefrom",
        //   sortable: true,
        //   class: "text-center"
        // },
        // {
        //   key: "date_to",
        //   label: "common.dateto",
        //   sortable: true,
        //   class: "text-center"
        // },
        {
          key: "last_value",
          label: "report.lastvalue",
          sortable: true,
          class: "text-center"
        },
        {
          key: "current_value",
          label: "report.currentvalue",
          sortable: true,
          class: "text-center"
        },
        {
          key: "price_unit",
          label: "report.price_unit",
          sortable: true,
          class: "text-center"
        },
        /*{
                    key: "vatAmount",
                    label: 'report.vat',
                    sortable: true,
                    class: "text-center"
                },*/
        // {
        //     key: "status",
        //     label: 'report.status',
        //     sortable: true,
        //     class: "text-center"
        // },
        {
          key: "amount",
          label: "report.totalfee",
          sortable: true,
          class: "text-center"
        },
        {
          key: "vat_percent",
          label: "report.vatPercent",
          sortable: true,
          class: "text-center"
        },
        {
          key: "vat_currency",
          label: "report.vatCurrency",
          sortable: true,
          class: "text-center"
        },
        {
          key: "total_all",
          label: "report.total_all",
          sortable: true,
          class: "text-center"
        },
        {
          key: "in_debt_value",
          label: "report.in_debt",
          sortable: true,
          class: "text-right"
        },
        {
          key: "description",
          label: "common.description",
          sortable: true,
          class: "text-center"
        },
        {
          key: "note",
          label: "report.noteChangeService",
          sortable: true,
          class: "text-center"
        },
        // {
        //     key: "total_all",
        //     label: "report.total_all",
        //     sortable: true,
        //     class: "text-center"
        // }
        // {
        //   key: "actions",
        //   label: "common.action",
        //   class: "text-center"
        // }
      ],
      // data for show list service Usage
      items: [],
      is_show_reset_liability: false,
      // MultiSelect Service availabe
      optionServiceSelected: [
        {
          name: "All",
          id: 0
        }
      ], //[{ name: 'Javascript', code: 'js' }]
      optionService: [
        {
          name: "All",
          id: 0
        }
      ], //[{"name":"Vue.js","code":"vu"},{"name":"Javascript","code":"js"},{"name":"Open Source","code":"os"}],
      disabledOptionService: true,
      service_usage_list: [],

      form: {
        date_issued: new Date(),
        date_paid: null,
        service: null,
        device: null,
        user: this.$route.params.id,
        due_date: ""
      },
      options: {
        format: "DD-MM-YYYY"
      },
      actionType: "",

      // ---- Apartment ----
      optionApartmentList: [
        {
          value: null,
          text: "Select One",
          apartment_id: null
        }
      ],
      optionApartmentSelected: null,
      apartmentDisabledList: true,
      // ---- Apartment ----

      // ---- User ----
      optionUserList: [
        {
          value: null,
          text: "Select One"
        }
      ],
      userDisabledList: true,
      // ---- User ----

      apartmentMonthlyUsageList: [],

      // Status Invoice List
      statusList: [
        {
          value: null,
          text: "Select One"
        }
      ],
      statusSelected: null,
      disabledStatusList: false,

      itemStatusList: [],
      statusListFull: [],

      pagetitle: "invoice.newinvoice",
      show: false,
      invoicedata: {
        id: 0,
        invoice_number: "",
        invoice_user: null,
        invoice_status: 2, // set default is Issued
        date_issued: new Date(),
        date_paid: new Date(),
        due_date: new Date(),
        apartment_id: "",
        other_details: "",
        mainowner: "",

        banktransfer: {
          account_no: "",
          account_name: "",
          transferring_content: "",
          contact_us: ""
        },

        periodSelected: "",

        apartment_code: "",

        exported_to_liability: false
      },
      invoiceDataInfo: {
        mainowner_fullname: "",
        mainowner_address: "",
        mainowner_email: "",
        mainowner_country: "",
        mainowner_phone: "",
        mainowner_tax: "",

        resident_fullname: "",
        resident_address: "",
        resident_email: "",
        resident_country: "",
        resident_phone: "",
        resident_tax: "",

        profile_company_name: "",
        profile_company_address: "",
        profile_company_tax_code: "",
        profile_company_email: ""
      },

      isModalVisible: false,
      objModal: [
        {
          title: "invoice.modaltitle",
          body: "invoice.modalbody",
          buttonNo: "common.cancel",
          buttonYes: "common.confirm",
          styleType: "default"
        }
      ],

      status: {
        Open: {
          key: 1,
          value: "Open"
        },
        Issued: {
          key: 2,
          value: "Issued"
        },
        Paid: {
          key: 3,
          value: "Paid"
        },
        Cancelled: {
          key: 4,
          value: "Cancelled"
        },
        Partial_Paid: {
          key: 5,
          value: "Partial Paid"
        },
        L: {
          key: 6,
          value: "Liability"
        }
      },

      Error: {
        invoice_user: "Customer is not empty",
        invoice_status: "Status is not empty",
        apartment_id: "The Apartment is not empty",
        periodSelected: "The Month is not empty",
        item: "List service usage is not empty"
      },

      periods: [],
      resident_list: [],
      periodDisabledList: false,
      objApartment: null,
      isLoading: false,
      isShowOnCreateReceipt: false,
      monthly_due_date: 5,

      einvoice_bkav: {
        invoice_data: {},
        invoice_data_info: {},
        service: {},
        is_create: true
      },
      invoiceType: null
    };
  },
  watch: {
    GET_LANG: function() {
      this.get_invoice_status_list();
    },

    // watch customer detail

    INVOICE_DETAIL_DATA: async function() {
      this.invoicedata.invoice_number = this.INVOICE_DETAIL_DATA.invoice_number;
      this.invoicedata.exported_to_liability = this.INVOICE_DETAIL_DATA.exported_to_liability;
      this.invoicedata.invoice_status = this.INVOICE_DETAIL_DATA.invoice_status.id;
      this.invoicedata.other_details = this.INVOICE_DETAIL_DATA.other_details;

      this.invoicedata.apartment_code = this.INVOICE_DETAIL_DATA.apartment.apartment_code;
      this.invoicedata.invoice_user_name = this.INVOICE_DETAIL_DATA.user.apartment_code;

      // Thông Tin Xuất Hóa Đơn Tới
      if (this.INVOICE_DETAIL_DATA.invoice_to_company_flag) {
        // Company
        this.invoiceDataInfo.resident_fullname =
          this.INVOICE_DETAIL_DATA.user.company_name + " - (C) ";
        // this.invoiceDataInfo.resident_fullname =
        //     this.INVOICE_DETAIL_DATA.user.company_name;
        this.invoiceDataInfo.resident_tax = this.INVOICE_DETAIL_DATA.user.company_tax_code;
        this.invoiceDataInfo.resident_address = this.INVOICE_DETAIL_DATA.user.company_address;
      } else {
        // Customer
        this.invoiceDataInfo.resident_fullname =
          this.INVOICE_DETAIL_DATA.user.name + " - (P) ";
        // this.invoiceDataInfo.resident_fullname =
        //     this.INVOICE_DETAIL_DATA.user.name;
        this.invoiceDataInfo.resident_tax = this.INVOICE_DETAIL_DATA.user.personal_tax_code;
        this.invoiceDataInfo.resident_address = this.INVOICE_DETAIL_DATA.apartment.apartment_code;
      }
      this.invoiceDataInfo.resident_email = this.INVOICE_DETAIL_DATA.user.email;
      this.invoiceDataInfo.resident_country = this.INVOICE_DETAIL_DATA.user.country;
      this.invoiceDataInfo.resident_phone = this.INVOICE_DETAIL_DATA.user.phone;

      if (this.INVOICE_DETAIL_DATA.date_issued == null) {
        this.form.date_issued = new Date();
      } else {
        this.form.date_issued = utils.formatSqlDate(this.INVOICE_DETAIL_DATA.date_issued, null, "DD-MM-YYYY");
      }
      this.invoicedata.date_issued = this.INVOICE_DETAIL_DATA.date_issued;
      let due_date = null;
      if (this.INVOICE_DETAIL_DATA.due_date == null) {
        if (this.INVOICE_DETAIL_DATA.date_issued == null) {
          due_date = new Date(
            this.form.date_issued.getFullYear(),
            this.form.date_issued.getMonth() + 1,
            this.monthly_due_date
          );
          //this.form.due_date = utils.formatSqlDate(due_date,  null, "DD-MM-YYYYThh:mm")
          this.form.due_date = due_date;
        } else {
          due_date = this.getDateDueInvoiceData()
          this.form.due_date = due_date;
        }
      } else {
        due_date = this.INVOICE_DETAIL_DATA.due_date;
        this.form.due_date = utils.formatSqlDate(due_date, null, "DD-MM-YYYYThh:mm");
      }

      this.invoicedata.due_date = due_date;
      if (this.INVOICE_DETAIL_DATA.date_paid == null) {
        this.form.date_paid = null;
      } else {
        this.form.date_paid = utils.formatSqlDate(this.INVOICE_DETAIL_DATA.date_paid, null, "DD-MM-YYYY");
      }
      this.invoicedata.date_paid = this.INVOICE_DETAIL_DATA.date_paid;

      // Process service_usage_list
      // this.optionService = [];

      if (this.INVOICE_DETAIL_DATA.invoice_to_company_flag) {
        // Company
        this.invoicedata.invoice_user =
          "C_" +
          this.INVOICE_DETAIL_DATA.client +
          "_" +
          this.INVOICE_DETAIL_DATA.invoice_to_company;
      } else {
        // User
        this.invoicedata.invoice_user = "P_" + this.INVOICE_DETAIL_DATA.client;
        this.invoiceDataInfo.resident_address = this.INVOICE_DETAIL_DATA.apartment.apartment_code;
      }

      this.invoicedata.apartment_id = this.INVOICE_DETAIL_DATA.apartment_id;
      this.invoicedata.periodSelected = utils.formatSqlDate(this.INVOICE_DETAIL_DATA.accounting_period, null, "MM");

      // [loitt] - add show banktransfer
      this.invoicedata.banktransfer.account_no = this.INVOICE_DETAIL_DATA.banktransfer ? this.INVOICE_DETAIL_DATA.banktransfer.account_no : "";
      this.invoicedata.banktransfer.account_name = this.INVOICE_DETAIL_DATA.banktransfer ? this.INVOICE_DETAIL_DATA.banktransfer.account_name : "";
      this.invoicedata.banktransfer.transferring_content = this.INVOICE_DETAIL_DATA.banktransfer? this.INVOICE_DETAIL_DATA.banktransfer.transferring_content : "";
      this.invoicedata.banktransfer.contact_us = this.INVOICE_DETAIL_DATA.banktransfer ? this.INVOICE_DETAIL_DATA.banktransfer.contact_us : "";

      // await this.onChangeApartment(this.invoicedata.apartment_id)
      // this.onChangeUser(this.invoicedata.invoice_user)
      this.bindingCustomer(this.INVOICE_DETAIL_DATA.apartment);

      this.items = [];
      this.optionServiceSelected = [];
      this.service_usage_list = [];
      this.invoicedata.total_fees = 0;
      this.INVOICE_DETAIL_DATA.service_usage_list.forEach((v, index) => {
        let vatAmount = utils.vatAmount(
          v.this_month_value,
          v.last_month_value,
          v.vat,
          v.price_unit
        );

        let data = {
          service_usage_id: index + 1,

          service_name: v.service.service_name,
          service_code: v.service.service_code,
          date_from: utils.formatSqlDate(v.date_from, null, "DD/MM/YYYY"),
          date_to: utils.formatSqlDate(v.date_to, null, "DD/MM/YYYY"),
          last_value: v.last_month_value,
          current_value: v.this_month_value,
          price_unit: v.price_unit,
          vat: v.vat, // store db
          vatAmount: vatAmount[0], // display
          apartment_id: v.apartment_id,
          // total_fee: vatAmount[1],
          // total_all: vatAmount[2],
          // status: v.invoice_status,
          show_action: true,
          vat_percent: v.vat_percent,
          vat_currency: v.vat_currency,
          amount: v.amount,
          total_all: v.total_fees,
          in_debt_value: v.in_debt_value,
          description: v.description,
          note: v.note
        };

        if (v.invoice_status.id == 3 || v.invoice_status.id == 6) {
          data["_rowVariant"] = "success";
          data["isReadOnly"] = true;
        } else {
          data["isReadOnly"] = false;
        }

        let dataOptionServiceUsage = {
          name: v.service.service_name,
          service_id: v.service.id
        };

        const found = this.optionService.some(
          el => el.service_id === v.service.id
        );
        if (!found) {
          this.optionService.push(dataOptionServiceUsage);
          this.optionServiceSelected.push(dataOptionServiceUsage);
        }

        // always add id to service_usage_list (id ~ service_usage_id)
        this.service_usage_list.push(v.id);
        // always add total_fees to service_usage_list (total_fees ~ total_fees)
        this.invoicedata.total_fees += data["total_all"];

        // Load to table Service Usage
        this.items.push(data);
      });
      // [loitt] - fixed makeRoundNumber
      this.invoicedata.total_fees = utils.makeRoundNumber(
        this.invoicedata.total_fees
      );
      // let dataSummary = {
      //   service_usage_id: "",
      //   service_name: "",
      //   service_code: "",
      //   date_from: "",
      //   date_to: "",
      //   last_value: "",
      //   current_value: "Tổng cộng",
      //   total_all: this.invoicedata.total_fees,
      //   // vat_percent: "",
      //   // vat_currency: "",
      //   show_action: false
      //   // status: null
      // };
      // this.items.push(dataSummary);
      this.einvoice_bkav.invoice_data = this.invoicedata;
      this.einvoice_bkav.invoice_data_info = this.invoiceDataInfo;
    }
  },
  computed: {
    functionExample: function() {
      return "";
    },
    ...mapGetters([
      "INVOICE_DETAIL_DATA",
      "GET_SNACK_BAR",
      "GENERATE_INVOICE_NUMBER",
      "GET_ACCOUNT_DATA",
      "GET_LANG"
    ])
  },
  methods: {
    show_hide_liability: function() {
      $("#modal-confirm-hide-liability").modal("show");
    },
    confirmHideLiability: function() {
      // let cash = this.invoicedata.total_fees
      let id = this.$route.params.id;
      this.HIDE_LIABILITY({ id: id }).then(
          function() {
            $("#modal-confirm-hide-liability").modal("hide");
            this.SUCCESS_TOAST();
            this.$router.push({
              name: "InvoiceList"
            });
          }.bind(this)
        )
        .catch(
          function() {
            $("#modal-confirm-hide-liability").modal("hide");
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    get_invoice_status_list() {
      this.statusList = [];
      this.itemStatusList = [];
      this.statusListFull = [];
      this.GET_INVOICE_STATUS_LIST().then(
        function(res) {
          let result = res.data;

          result.results.forEach(v => {
            this.statusListFull.push(v);

            let data = {
              text: this.getStatusName(v),
              value: v.id
            };
            if (
              v.status_description == this.status.Issued.value ||
              v.status_description == this.status.Paid.value ||
              v.status_description == this.status.L.value
            ) {
              this.statusList.push(data);
              this.itemStatusList.push(data);
            } else if (v.status_description == this.status.Partial_Paid.value) {
              this.statusList.push(data);
            }
          });
        }.bind(this)
      );
    },
    getStatusName(v) {
      let language_status_name = "invoice.invoice_status." + v.status_code;
      let status_name = this.$t(language_status_name); //invoice.invoice_status.status_description;
      if (utils.isEnglishLanguage(i18n.locale)) {
        return status_name;
      } else {
        return status_name;
      }
    },
    formatTotalFee: function(total_fee) {
      if (total_fee != undefined) {
        return utils.formatNumber(utils.makeRoundNumber(total_fee));
      }
    },
    getDueDate(e) {
      // let due_date = e.date.set("date", 5).add(1, "M").format("DD-MM-YYYY");
      // this.form.due_date = due_date;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ADD_INVOICE",
      "GET_INVOICE_DETAIL",
      "HIDE_LIABILITY",
      "UPDATE_INVOICE",
      "GET_INVOICE_STATUS_LIST",
      "CHECK_INVOICE_VS_HOMEACCOUNTINGLIABILITY",
      // "GET_APARTMENT_MONTHLY_USAGE_LIST",
      "GET_APARTMENT_USAGE_LIST",
      "ON_SHOW_TOAST",
      "GENERATE_INVOICE_ID",
      "GET_PROJECT_BANK_TRANSFER",
      "CREATE_ACCOUNTING_HOME_LIABILITY_FROM_INVOICE"
    ]),
    cancelInvoiceList: function() {
      this.$router.push({
        name: "InvoiceList",
        query: this.$route.query
      });
    },
    validateData: function() {
      let validatedResult = "OK";
      for (let key in this.invoicedata) {
        // console.log("key[" + key + "] = value["+ this.invoicedata[key] + "]")
        if (
          key == "other_details" ||
          key == "date_paid" ||
          key == "apartment_code"
        ) {
          continue;
        }

        if (this.invoicedata[key] === null || this.invoicedata[key] === "") {
          validatedResult = this.Error[key];
          break;
        } else {
          //
        }
      }

      if (this.items == null || this.items.length == 0) {
        validatedResult = this.Error["item"];
      }

      return validatedResult;
    },
    // Generate invoice number by time option 1
    generateInvoiceNumberOption1: function(subObject) {
      let invoiceNumber = subObject + new Date().getTime().toString(36);
      return invoiceNumber;
    },
    // Generate invoice number by time option 2
    generateInvoiceNumberOption2: function(subObject) {
      var date = new Date();
      var components = [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
      ];
      var id = components.join("");
      return subObject + id;
    },
    generateInvoiceNumberOption3: function(subObject) {
      return this.GENERATE_INVOICE_ID().then(function(res) {
        let result = res.data;
        return result;
      });
    },

    addService: function(newTag) {
      // console.log(newTag);
      // const tag = {
      //   name: newTag,
      //   code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      // }
      // this.options.push(tag)
      // this.value.push(tag)
    },

    async onChangeApartment(val) {
      // console.log("onChangeApartment apartment id : " + val);
      if (val == null) {
        return;
      }

      // Task 4: Add one field (Ch? S? H?u) at invoice detail screen.
      // const data = {
      //     params: {
      //         page: 1,
      //         apartment: val
      //     }
      // };

      this.optionApartmentSelected = val;
      this.objApartment = null;
      this.objApartment = this.optionApartmentList.filter(
        item => item.value == val
      )[0].apartment;

      // with constructor:
      // apartmentservices: Tất cả dịch vụ
      // resident : Thông tin Căn hộ
      // apartmentMonthlyUsage: Dịch vụ đã sử dụng

      // Binding IN CUSTOMER
      this.bindingCustomer(this.objApartment);

      // reset list
      this.items = [];
      // this.optionService = []
      // this.optionServiceSelected = []

      if (val == null) {
        return;
      }

      // ***************************************************
      //              combobox user
      // ***************************************************
      // set default combobox user  is not select
      this.invoicedata.invoice_user = null;
      // Load combobox user
      this.loadUser();
      // ***************************************************

      // ***************************************************
      //              combobox service
      // ***************************************************
      // set default combobox service is select ALL
      this.optionServiceSelected = [
        {
          name: "All",
          id: 0
        }
      ];
      // Load combobox service
      this.loadService();
      // ***************************************************

      // Update apartmentMonthlyUsageList - List apartment monthly Usage
      this.apartmentMonthlyUsageList = this.objApartment.apartmentMonthlyUsage;

      this.loadServiceUsage(
        val,
        null,
        this.optionServiceSelected,
        this.$route.params.id
      );
    },

    bindingCustomer(objApartment) {
      let result = objApartment.resident.filter(
        item => item.isOwner == true || item.isTenant == true
      );

      let full_name =
        result[0].resident.last_name + " " + result[0].resident.first_name;
      this.invoicedata.mainowner = full_name;

      this.invoiceDataInfo.mainowner_fullname = full_name;
      this.invoiceDataInfo.mainowner_address = objApartment.code;
      this.invoiceDataInfo.mainowner_email = result[0].resident.email;
      this.invoiceDataInfo.mainowner_country = result[0].resident.country;
      this.invoiceDataInfo.mainowner_tax = result[0].resident.personal_tax_code;
      this.invoiceDataInfo.mainowner_phone = result[0].resident.phone;

      // [loitt] - #1171 GHI NHẬN THÔNG TIN XUẤT HOÁ ĐƠN
      this.invoiceDataInfo.profile_company_name =
        result[0].resident.profile_company_name;
      this.invoiceDataInfo.profile_company_address =
        result[0].resident.profile_company_address;
      this.invoiceDataInfo.profile_company_tax_code =
        result[0].resident.profile_company_tax_code;
      this.invoiceDataInfo.profile_company_email =
        result[0].resident.profile_company_email;
    },

    //
    // [loitt] - Load combobox user - Danh sách Tên Người Xuất
    //
    loadUser() {
      const dataUser = [
        {
          value: null,
          text: "Select One"
        }
      ];
      // this.invoicedata.invoice_user = null
      this.optionUserList = dataUser;

      // LOAD info User
      let listMonthlyUsageListByUser = this.objApartment.apartmentMonthlyUsage.map(
        e => e.user
      );
      // Remove duplicate
      let listUser = this.getUnique(listMonthlyUsageListByUser, "id");
      // console.log(JSON.stringify(this.objApartment))

      listUser.forEach(function(v) {
        let data = {
          value: "P_" + v.id,
          text: v.fullname + " - (P)",
          resident: v
        };
        if (v.id != 0) {
          dataUser.push(data);
        }

        // process for company
        if (v.is_company) {
          data = {
            value: "C_" + v.id + "_" + v.company_id,
            text: v.company_name + " - (C)",
            resident: v
          };
          dataUser.push(data);
        }
      });
      this.optionUserList = dataUser;
    },
    //
    // [loitt] - Load combobox service - Danh sách Dịch Vụ Sử Dụng
    //
    loadService() {
      // LOAD info Service
      let optionService = this.objApartment.apartmentMonthlyUsage.map(
        e => e.service_details
      );

      this.optionService = this.getUnique(optionService, "id");

      // All field ALL
      this.optionService.push({
        name: "All",
        id: 0
      });
    },

    loadServiceUsage(apartment_id, user_id, listService, invoice_id) {
      // console.log("================================================")
      // console.log("apartment_id = " + apartment_id)
      // console.log("user_id = " + user_id)
      // console.log("listService = ")
      // console.log(JSON.stringify(listService))
      // console.log("invoice_id = " + invoice_id)
      // console.log("================================================")

      let listIdService = null;
      if (listService != null) {
        listIdService = listService.map(e => e.id);
        // Fixed select All show all service
        if (listIdService.includes(0)) {
          listIdService = this.optionService
            .filter(item => item.id > 0)
            .map(e => e.id);
        }
      }

      this.service_usage_list = [];

      this.items = [];

      const dataSearch = [];
      const service_usage_list_service = [];
      this.invoicedata.total_fees = 0;
      let total_fees = 0;

      let objectSelectMonth = this.periods.filter(
        item => item.value == this.invoicedata.periodSelected
      );

      //===================
      if (user_id == null || user_id == "P_null" || user_id == "C_null") {
        user_id = null;
      }

      let export_invoice_to = null;
      let type_export_invoice_to = null;
      if (user_id != null) {
        // 0 :  C: Company - P : Personal
        // 1 :  id invoice to
        // 2 :  id company
        let arrayInvoiceTo = user_id.split("_");
        // always update
        export_invoice_to = arrayInvoiceTo[1];
        type_export_invoice_to = arrayInvoiceTo[0];
      }
      //===================

      this.apartmentMonthlyUsageList.forEach(
        function(v) {
          // if (v.apartment_id == apartment_id && (listIDCustomer == null || listIDCustomer.includes(v.user.id))) {

          // Date from
          let date_to = new Date(v.date_to);
          // Date selected
          if (objectSelectMonth.length > 0) {
            let dateSelected = new Date(objectSelectMonth[0].date);
            if (!this.validateDayInSpecificPeriod(date_to, dateSelected)) {
              return;
            }
          }
          // console.log("x1")
          // console.log(v.apartment + " " + apartment_id)
          // console.log(export_invoice_to)
          // console.log(export_invoice_to + " " +  v.user.id)
          // console.log(listIdService)
          // console.log(listIdService.length)
          // console.log(JSON.stringify(listIdService))

          if (
            v.apartment == apartment_id &&
            (export_invoice_to == null || export_invoice_to == v.user.id) &&
            (listIdService == null ||
              listIdService.length == 0 ||
              listIdService.includes(v.service.id))
          ) {
            let vatAmount = utils.vatAmount(
              v.this_month_value,
              v.last_month_value,
              v.vat,
              v.price_unit
            );
            let data = {
              service_usage_id: v.id,
              service_name: v.service_details.name,
              service_code: v.service_details.servicecode,
              date_from: utils.formatSqlDate(v.date_from, null, "DD/MM/YYYY"),
              date_to: utils.formatSqlDate(v.date_to, null, "DD/MM/YYYY"),
              last_value: v.last_month_value,
              current_value: v.this_month_value,
              price_unit: v.price_unit,
              vat: v.vat, // store db
              vatAmount: vatAmount[0], // display
              status: v.status,
              // total_fee: vatAmount[1],
              // total_all: vatAmount[2],
              show_action: false
            };

            if (v.status.id == 3 || v.last_month_value == v.this_month_value) {
              data["_rowVariant"] = "success";
              data["isReadOnly"] = true;
              data["status"] = Object.assign(
                {},
                this.statusListFull.filter(item => item.status_code == "P")[0]
              );
            } else {
              data["isReadOnly"] = false;
              data["status"] = Object.assign(
                {},
                this.statusListFull.filter(item => item.status_code == "I")[0]
              );
            }

            // console.log("x4")
            if (invoice_id == 0 && v.invoice == null) {
              if (type_export_invoice_to == null) {
                //total_fees = total_fees + v.total_fees
                total_fees = total_fees + vatAmount[2];
                service_usage_list_service.push(v.id);
                // data.status.id = 2 // set default is Issued
                // console.log("x5")
                dataSearch.push(data);
              } else if (type_export_invoice_to == "C" && v.is_company) {
                //total_fees = total_fees + v.total_fees
                total_fees = total_fees + vatAmount[2];
                service_usage_list_service.push(v.id);
                // data.status.id = 2 // set default is Issued
                // console.log("x6")
                dataSearch.push(data);
              } else if (type_export_invoice_to == "P" && !v.is_company) {
                //total_fees = total_fees + v.total_fees
                total_fees = total_fees + vatAmount[2];
                service_usage_list_service.push(v.id);
                // data.status.id = 3 // set default is Issued
                // console.log("x7")
                dataSearch.push(data);
              }
            } else if (invoice_id != 0 && v.invoice != null) {
              // console.log("x8")
              total_fees = total_fees + data["total_fee"];
              service_usage_list_service.push(v.id);
              dataSearch.push(data);
            }

            // dataSearch.push(data);
          }
        }.bind(this)
      );

      // [loitt] - fixed makeRoundNumber
      total_fees = utils.makeRoundNumber(total_fees);

      // Set summary line
      let dataSummary = {
        service_usage_id: "",
        service_name: "",
        date_from: "",
        date_to: "",
        last_value: "",
        current_value: "Summary",
        status: null,
        total_all: total_fees,
        show_action: false
      };

      // set total_fees
      this.invoicedata.total_fees = total_fees;

      this.items = dataSearch;
      // console.log(JSON.stringify(this.items))
      if (this.items.length > 0) {
        this.service_usage_list = service_usage_list_service;
        this.items.push(dataSummary);
      }

      this.onSelected();
    },
    validateDayInSpecificPeriod(day, selectedPeriod) {
      let period_start = new Date(
        selectedPeriod.getFullYear(),
        selectedPeriod.getMonth() - 1,
        26
      );
      let period_end = new Date(
        selectedPeriod.getFullYear(),
        selectedPeriod.getMonth(),
        25
      );
      day = new Date(day.getFullYear(), day.getMonth(), day.getDate());
      if (day >= period_start && day <= period_end) {
        return true;
      }
      return false;
    },
    getUnique(arr, comp) {
      const unique = arr
        .map(e => e[comp])
        // store the keys of the unique objects
        .map((e, i, final) => final.indexOf(e) === i && i)
        // eliminate the dead keys & store unique objects
        .filter(e => arr[e])
        .map(e => arr[e]);

      return unique;
    },
    // [ACTION_02] - Select User
    // 1. Select User - Ex: select user 1
    // 2. Add service to list Services Usage by user selected - Ex: Show list Service (removed duplicate)
    onChangeUser(val) {
      if (val == null || val == "P_null" || val == "C_null") {
        val = null;
      }

      this.invoicedata.invoice_user = val;
      // let export_invoice_to = null
      if (val != null) {
        // 0 :  C: Company - P : Personal
        // 1 :  id invoice to
        // 2 :  id company
        let arrayInvoiceTo = val.split("_");
        // always update

        // export_invoice_to = arrayInvoiceTo[1]

        let type_export_invoice_to = arrayInvoiceTo[0];

        let result = this.optionUserList.filter(item => item.value == val);
        let full_name =
          result[0].resident.first_name + " " + result[0].resident.last_name;
        this.invoiceDataInfo.resident_fullname = full_name;

        this.invoiceDataInfo.resident_email = result[0].resident.email;
        this.invoiceDataInfo.resident_country = result[0].resident.country_name;
        this.invoiceDataInfo.resident_phone = result[0].resident.phone;
        // C: Company - P : Personal
        if (type_export_invoice_to == "C") {
          this.invoiceDataInfo.resident_tax =
            result[0].resident.company_tax_code;
          this.invoiceDataInfo.resident_address =
            result[0].resident.company_address;
        } else {
          this.invoiceDataInfo.resident_address = this.objApartment.code;
          this.invoiceDataInfo.resident_tax =
            result[0].resident.personal_tax_code;
        }
      }

      // [{"id":5,"username":"uuser1","lastname":"1","firstname":"T","fullname":"1 T","email":"admin1@gmail.com","phone":"0"}]

      let apartment_id = this.optionApartmentSelected;
      if (apartment_id != null) {
        this.loadServiceUsage(
          apartment_id,
          val,
          this.optionServiceSelected,
          this.$route.params.id
        );
      }
    },

    onChangeService(val) {
      if (val.length == 0) {
        this.optionServiceSelected = [
          {
            name: "All",
            id: 0
          }
        ];
      }

      if (val.length > 1) {
        let lastedItem = val[val.length - 1];
        if (lastedItem.name == "All") {
          this.optionServiceSelected = [
            {
              name: "All",
              id: 0
            }
          ];
        } else {
          val = val.filter(function(item) {
            return item.name != "All";
          });

          if (val.length == this.optionService.length - 1) {
            this.optionServiceSelected = [
              {
                name: "All",
                id: 0
              }
            ];
          } else {
            this.optionServiceSelected = val;
          }
        }
      }

      let apartment_id = this.optionApartmentSelected;
      if (apartment_id != null) {
        this.loadServiceUsage(
          apartment_id,
          this.invoicedata.invoice_user,
          val,
          this.$route.params.id
        );
      }
    },
    onSelected: function() {
      let list_status_id = [];
      for (var i = 0; i < this.items.length - 1; i++) {
        let obj_status = Object.assign(
          {},
          this.statusListFull.filter(e => e.id == this.items[i].status.id)[0]
        );
        list_status_id.push(obj_status.id);
      }
      if (list_status_id.every(x => x == this.status.Paid.key)) {
        // All Paid
        this.invoicedata.invoice_status = this.status.Paid.key;
      } else if (list_status_id.every(x => x == this.status.Issued.key)) {
        this.invoicedata.invoice_status = this.status.Issued.key;
      } else {
        this.invoicedata.invoice_status = this.status.Partial_Paid.key;
      }
    },

    onSelectedMonth: function() {
      // get object selected
      let objectSelectMonth = this.periods.filter(
        item => item.value == this.invoicedata.periodSelected
      );
      if (objectSelectMonth.length > 0) {
        let date_issued = new Date(objectSelectMonth[0].date);
        // update due date
        let due_date = new Date(
          date_issued.getFullYear(),
          date_issued.getMonth() + 1,
          this.monthly_due_date
        );
        this.form.due_date = due_date;
        this.invoicedata.due_date = due_date;
      }

      this.onChangeApartment(this.invoicedata.apartment_id);
    },

    onConfirm: function() {
      this.isModalVisible = false;
    },
    showPrintPdf: function() {
      let routeData = this.$router.resolve({
        name: "InvoicePdfFilter",
        query: {
          templateId: utils.getSessionKeyInt('invoiceTemplate', InvoiceTemplateEnum.REPUBLIC_PALAZA),
          list_invoice_ids: this.invoicedata.id,
          is_price_contain: 1,
          picked: 2,
          invoiceType: this.invoiceType
        }
      });
      window.open(routeData.href, "_blank");
    },
    onCreateReceipt: function() {
      this.$router.push({
        name: "ReceiptAdd",
        params: {
          id: 0
        },
        query: {
          invoice_id: this.invoicedata.id
        }
      });
    },
    onCreateLiabilit: function() {
      $(this.$refs[`modal-main-liability`]).modal("show");
    },
    onSaveLiability: function() {
      this.isLoading = true;
      let data = {
        invoice_list_id: [this.$route.params.id],
        user_created: this.GET_ACCOUNT_DATA.id
      };
      // init empty
      this.resultImportList = [];
      this.CREATE_ACCOUNTING_HOME_LIABILITY_FROM_INVOICE(data).then(
        function(res) {
          this.ON_SHOW_TOAST({
            message: this.$t("invoice.liability.success"),
            styleType: "success"
          });
          let invoiceFilter = {
            id: id
          }
          this.GET_INVOICE_DETAIL(invoiceFilter);

          this.isLoading = false;
        }.bind(this)
      )
      .catch(
        function(error) {
          this.ON_SHOW_TOAST({
            message: error,
            styleType: "danger"
          });
          this.isLoading = false;
        }.bind(this)
      );

      $(this.$refs[`modal-main-liability`]).modal("hide");
    },

    // Process save and update invoice
    saveInvoiceList: function(event) {
      let result = this.validateData();
      if (result == "OK") {
        let current_val_user = this.invoicedata.invoice_user;
        // 0 :  C: Company - P : Personal
        // 1 :  id invoice to
        // 2 :  id company
        let arrayVal = current_val_user.split("_");

        let type_user = arrayVal[0];
        let client_id = arrayVal[1];
        let invoice_to_company = null;
        let invoice_to_company_flag = null;

        // C: Company - P : Personal
        if (type_user == "C") {
          invoice_to_company = arrayVal[2];
          invoice_to_company_flag = true;
        } else {
          invoice_to_company = null;
          invoice_to_company_flag = false;
        }

        let banktransfer = {
          account_no: this.invoicedata.banktransfer.account_no,
          account_name: this.invoicedata.banktransfer.account_name,
          transferring_content: this.invoicedata.banktransfer
            .transferring_content,
          contact_us: this.invoicedata.banktransfer.contact_us
        };

        let data = {
          invoice_number: this.invoicedata.invoice_number,
          client_id: client_id,
          invoice_status_id: this.invoicedata.invoice_status,
          date_issued: this.invoicedata.date_issued,
          // due_date: utils.formatSqlDate(this.invoicedata.due_date, null, "DD-MM-YYYYThh:mm"),
          due_date: this.invoicedata.due_date,
          date_paid: this.invoicedata.date_paid, // utils.formatSqlDate(this.form.date_paid, null, "DD-MM-YYYY"),
          total_fees: utils.makeRoundNumber(this.invoicedata.total_fees),
          other_details: this.invoicedata.other_details,
          apartment_id: this.optionApartmentSelected,
          service_usage_list: this.service_usage_list, //this.optionServiceSelected.map(e => e.code),
          item_service_usage_list: this.items,
          id: this.invoicedata.id,
          period: this.invoicedata.periodSelected,
          invoice_to_company: invoice_to_company,
          invoice_to_company_flag: invoice_to_company_flag,
          banktransfer: banktransfer,
          user_created: this.GET_ACCOUNT_DATA.id
        };
        if (parseInt(this.invoicedata.id) == 0) {
          this.ADD_INVOICE(data).then(
            function() {
              this.$router.push({
                name: "InvoiceList"
              });
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error,
                styleType: "danger"
              });
            }.bind(this)
          );
        } else {
          this.UPDATE_INVOICE(data).then(
            function() {
              this.$router.push({
                name: "InvoiceList"
              });
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error,
                styleType: "danger"
              });
            }.bind(this)
          );
        }
      } else {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      }
    },
    openModalEinvoice: function(id_modal, item) {
      this.einvoice_bkav.service = item;
      this.einvoice_bkav.is_create = true;
      this.$refs.LTEModalEInvoiceBkav.updateInfoEinvoiceBkav();
    },
    closeModalEinvoice: function(id_modal) {
      $("#" + id_modal).modal("hide");
    },
    getDateDueInvoiceData: function() {
      let result = ''
      let formatDate = "YYYY-MM-DD"
      let toFormatDate = "DD-MM-YYYY"
      let monthlyDueDate = sessionStorage.getItem('projectMonthlyDueDate')
      let nowTime = moment().format(formatDate)
      let projectDueDate = null
      if (monthlyDueDate) {
        projectDueDate = utils.formatSqlDate(monthlyDueDate, "DD", formatDate)
        if (nowTime >= projectDueDate) {
          result = moment(projectDueDate, formatDate).add(1, 'month').format(toFormatDate)
        } else {
          result = utils.formatSqlDate(projectDueDate, formatDate, toFormatDate)
        }
      }
      return result
    }
  },
  created() {
    this.GET_PROJECT_BANK_TRANSFER()
      .then(
        function(res) {
          let data = res.data.data[0];
          this.invoicedata.banktransfer.account_no =
            data.bank_account_no +
            " - " +
            data.bank_code.bank_name +
            " - " +
            data.bank_other_details;
          this.invoicedata.banktransfer.account_name = data.bank_account_name;
          this.invoicedata.banktransfer.transferring_content = data.bank_transferring_content;
          this.invoicedata.banktransfer.contact_us = data.bank_contact_us;
        }.bind(this)
      )
      .catch(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
  },
  async mounted() {
    // this.isLoading = true;
    // 2. GET GET_APARTMENT_USAGE_LIST - Mã Căn
    // 3. SELECT Mã Căn - onChangeApartment
    // 4. SELECT Tên Người Xuất - onChangeUser
    // 5. SELECT Dịch Vụ Sử Dụng - onChangeService
    let monthlyDueDate = sessionStorage.getItem('projectMonthlyDueDate')
    // TODO: remove hardcode
    this.monthly_due_date = monthlyDueDate === null ? 5 : monthlyDueDate;
    // update due date
    let due_date = new Date(
      this.form.date_issued.getFullYear(),
      this.form.date_issued.getMonth() + 1,
      this.monthly_due_date
    );
    //this.form.due_date = utils.formatSqlDate(due_date, null, "DD-MM-YYYYThh:mm")
    this.form.due_date = due_date;
    this.invoicedata.due_date = due_date;

    // Set data for select INVOICE_STATUS - [ACTION_01]
    this.get_invoice_status_list();

    // //////////////////////////////
    // Add or Update data
    // //////////////////////////////
    let id = this.$route.params.id;

    if (parseInt(id) !== 0) {
      let invoiceType = this.$route.query.invoiceType
      this.invoiceType = invoiceType
      this.invoicedata.id = id;
      this.pagetitle = "invoice.editinvoice";
      let invoiceFilter = {
        id: id
      }
      await this.GET_INVOICE_DETAIL(invoiceFilter);
      this.show = true;
      // this.disabledStatusList = false;
      // this.userDisabledList = false;
      // this.apartmentDisabledList = false;

      let service_usage_list_issued_basic = this.INVOICE_DETAIL_DATA.service_usage_list
        .filter(item => item.invoice_status.status_code == "I")
        .map(e => e.service.id);
      if (service_usage_list_issued_basic.length > 0) {
        this.isShowOnCreateReceipt = true;
      } else {
        this.isShowOnCreateReceipt = false;
      }

      this.disabledOptionService = false;
      this.periodDisabledList = false;
      this.CHECK_INVOICE_VS_HOMEACCOUNTINGLIABILITY({ id: id }).then(
        function(res) {
          this.is_show_reset_liability = res;
        }.bind(this)
      );
    } else {
      this.apartmentMonthlyUsageList = [];
      await this.GET_APARTMENT_USAGE_LIST().then(
        function(res) {
          let result = res.data;
          result.forEach(v => {
            let data = {
              text: v.apartment_code,
              value: v.id,
              apartment: v
            };
            this.optionApartmentList.push(data);
          });

          this.isLoading = false;
        }.bind(this)
      );

      // [ACTION_ADD_INVOICE] - [ACTION_01]
      this.invoicedata.invoice_number = await this.generateInvoiceNumberOption3();
      // Set disable
      this.userDisabledList = true;
      this.apartmentDisabledList = true;
      this.disabledStatusList = false;
      this.disabledOptionService = true;

      this.optionApartmentSelected = null;
      this.periodDisabledList = true;
    }

    this.isLoading = false;
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker,
    Multiselect,
    "lte-modal": LTEModal,
    loading: Loading,
    "lte-modal-einvoice": LTEModalEInvoiceBkav
  }
};
</script>

<style scoped>
.table-success {
  border-color: #8fd19e;
  background-color: #ddd;
}

.btn-owner {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  background-color: #337ab7;
  border-color: #2e6da4;
}

.btn-tenant {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  background-color: #f0ad4e;
  border-color: #eea236;
}

.btn-null {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  background-color: #5cb85c;
  border-color: #4cae4c;
}

/* Tooltip container */
.tooltip-button {
  display: inline;
  position: relative;
}

.tooltip-button:hover:after {
  background: #333;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
  bottom: 26px;
  color: #fff;
  content: attr(title);
  left: 20%;
  padding: 5px 15px;
  position: absolute;
  z-index: 98;
  width: 220px;
}

.tooltip-button:hover:before {
  border: solid;
  border-color: #333 transparent;
  border-width: 6px 6px 0 6px;
  bottom: 20px;
  content: "";
  left: 50%;
  position: absolute;
  z-index: 99;
}
.hidden {
  display: none;
}
.label-darkcyan {
  background-color: darkcyan !important;
}
.label-crimson {
  background-color: crimson !important;
}
.label-darkblue {
  background-color: darkblue !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Invoice/InvoiceAdd.vue